import { type Icon as LucideIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

interface IconProps extends React.ComponentPropsWithoutRef<'svg'> {
  icon: typeof LucideIcon;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
};

export function Icon({ icon: Icon, size = 'md', className, ...props }: IconProps) {
  return (
    <Icon className={cn(sizeMap[size], className)} {...props} />
  );
}
